export class Transformation {
  // This class handles all sorts of different ways to switch around a Tic Tac Toe game

  constructor (reflectH, rotate) {
    this.reflectH = reflectH; // boolean
    // this.reflectV = reflectV; // boolean
    this.rotate = rotate; // integer 0-3
  }

  // Transform boards
  // static reflectV (board) { // Returns this.board, reflected along a vertical line
  //   return [null,
  //     board[3], board[2], board[1],
  //     board[6], board[5], board[4],
  //     board[9], board[8], board[7]
  //   ];
  // }
  static reflectH (board) { // Returns this.board, reflected along a horizontal line
    return [null,
      board[7], board[8], board[9],
      board[4], board[5], board[6],
      board[1], board[2], board[3]
    ];
  }
  static rotate (board) { // Returns this.board, rotated tau/4 radians
    return [null,
      board[7], board[4], board[1],
      board[8], board[5], board[2],
      board[9], board[6], board[3]
    ];
  }
  static rotateBack (board) { // Returns this.board, rotated tau/4 radians in the other direction
    return [null,
      board[3], board[6], board[9],
      board[2], board[5], board[8],
      board[1], board[4], board[7]
    ];
  }

  // Transform moves
  // static reflectVMove (move) { // Returns this.board, reflected along a vertical line
  //   switch (move) {
  //     case 1: return 3;
  //     case 2: return 2;
  //     case 3: return 1;
  //     case 4: return 6;
  //     case 5: return 5;
  //     case 6: return 4;
  //     case 7: return 9;
  //     case 8: return 8;
  //     case 9: return 7;
  //     default: return;
  //   };
  // }
  static reflectHMove (move) { // Returns this.board, reflected along a horizontal line
    switch (move) {
      case 1: return 7;
      case 2: return 8;
      case 3: return 9;
      case 4: return 4;
      case 5: return 5;
      case 6: return 6;
      case 7: return 1;
      case 8: return 2;
      case 9: return 3;
      default: return;
    };
  }
  static rotateMove (move) { // Returns this.board, rotated tau/4 radians
    switch (move) {
      case 1: return 7;
      case 2: return 4;
      case 3: return 1;
      case 4: return 8;
      case 5: return 5;
      case 6: return 2;
      case 7: return 9;
      case 8: return 6;
      case 9: return 3;
      default: return;
    };
  }
  static rotateBackMove (move) { // Returns this.board, rotated tau/4 radians in the other direction
    switch (move) {
      case 1: return 3;
      case 2: return 6;
      case 3: return 9;
      case 4: return 2;
      case 5: return 5;
      case 6: return 8;
      case 7: return 1;
      case 8: return 4;
      case 9: return 7;
      default: return;
    };
  }

  // Methods
  transform (board, transformation = this) {
    if (transformation.reflectH) board = Transformation.reflectH(board);
    // if (transformation.reflectV) board = Transformation.reflectV(board);
    for (let r = 0; r < transformation.rotate; r ++) {
      board = Transformation.rotate(board);
    }
    return board;
  }
  transformBack (board, transformation = this) {
    for (let r = 0; r < transformation.rotate; r ++) {
      board = Transformation.rotateBack(board);
    }
    if (transformation.reflectH) board = Transformation.reflectH(board);
    // if (transformation.reflectV) board = Transformation.reflectV(board);
    return board;
  }
  transformMove (move, transformation = this) {
    if (transformation.reflectH) move = Transformation.reflectH(move);
    // if (transformation.reflectV) move = Transformation.reflectV(move);
    for (let r = 0; r < transformation.rotate; r ++) {
      move = Transformation.rotate(move);
    }
    return move;
  }
  transformBackMove (move, transformation = this) {
    for (let r = 0; r < transformation.rotate; r ++) {
      move = Transformation.rotateMove(move);
    }
    if (transformation.reflectH) move = Transformation.reflectHMove(move);
    // if (transformation.reflectV) move = Transformation.reflectVMove(move);
    return move;
  }
}


function arraysEqual(a, b) {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;

  // If you don't care about the order of the elements inside
  // the array, you should sort both arrays here.
  // Please note that calling sort on an array will modify that array.
  // you might want to clone your array first.

  for (var i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}


export class Move {
  constructor (index, score) {
    this.index = index;
    this.score = score;
  }
  setScore(score) {
    this.score = score;
  }
  addToScore(amount) {
    this.score += amount;
  }
}


export class MemoryFragment {
  // this.board[0] is always null
  constructor (board = [], playerMove = null) {
    this.board = board;
    this.nextMoves = [];
    this.fillNextMoves();
    this.lastBestMoveIndex = 0;
  }
  fillNextMoves () {
    for (let i = 1; i < 10; i ++) {
      if (this.board[i] === "") {
        this.nextMoves.push(new Move(i, Math.random())); // random move score between 0 and 1 so we'll always have one to choose
      }
    }
  }
  addToScore (amount) {
    this.nextMoves[this.lastBestMoveIndex].addToScore(amount);
  }
  divideScoreBy (amount) {
    this.nextMoves[this.lastBestMoveIndex].score /= amount;
  }
  makeNegative () {
    this.nextMoves[this.lastBestMoveIndex].score = Math.min(this.nextMoves[this.lastBestMoveIndex].score, -1);
  }
  getBestMove () {
    let bestScore = this.nextMoves[0].score;
    let bestScoreIndex = 0;
    for (let i = 0; i < this.nextMoves.length; i ++) {
      if (this.nextMoves[i].score > bestScore) {
        bestScore = this.nextMoves[i].score;
        bestScoreIndex = i;
      }
    }
    this.lastBestMoveIndex = bestScoreIndex;
    console.log("Score: " + bestScore);
    console.log("Move index: " + this.nextMoves[bestScoreIndex].index);
    return this.nextMoves[bestScoreIndex].index;
  }
  searchMemory (board) { // returns a Transformation object
    // We rotate the board, then reflect it, then rotate it, then reflect it the other way, looking for a transformation that matches up the boards
    // If this is discovered, we return the transformation. If not null.

    // IMPORTANT: I just realized that there's no need to reflect it along more than one axis if we're rotating it.

    for (let h = 0; h < 2; h ++) {
      // for (let v = 0; v < 2; v ++) {
        for (let r = 0; r < 4; r ++) {
          // Here is where we check to see if they literally match
          if (arraysEqual(board, this.board)) {
            // time to return a transformation array
            return new Transformation(
              h === 1,
              // v == 1,
              r
            );
          }

          board = Transformation.rotate(board);
        }
        // board = Transformation.reflectV(board);
      // }
      board = Transformation.reflectH(board);
    }
    return null;
  }
  static alertBoard (board) {
    alert(`Heres the board:\n${board[7]} - ${board[8]} - ${board[9]}\n${board[4]} - ${board[5]} - ${board[6]}\n${board[1]} - ${board[2]} - ${board[3]}`);
  }
}
